import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const getSubscriptions = createAsyncSagaAction(actionTypes.GET_SUBSCRIPTIONS);
export const getCurrentUserInit = createAsyncSagaAction(actionTypes.GET_CURRENT_USER_INIT);

export const getSettings = createAsyncSagaAction(actionTypes.GET_SETTINGS);
export const createAccount = createAsyncSagaAction(actionTypes.CREATE_ACCOUNT);
export const createAccountForPublicOrg = createAsyncSagaAction(actionTypes.CREATE_ACCOUNT_FOR_PUBLIC_ORG);
export const withinGeoFence = createAsyncSagaAction(actionTypes.WITHINGEOFENCE);
export const getPrivateUserInfo = createAsyncSagaAction(actionTypes.GETPRIVATEUSERINFO);
export const getAsIsState = createAsyncSagaAction(actionTypes.MAP_PHONE_TO_SUBMIT);
export const getAsIsPhone = createAsyncSagaAction(actionTypes.MAP_PHONE_TO_SUBMIT);
export const fetchCountries = createAsyncSagaAction(actionTypes.FETCH_COUNTRIES);
export const fetchPublicProfile = createAsyncSagaAction(actionTypes.FETCH_PUBLIC_PROFILE);
export const fetchLanguageSettings = createAsyncSagaAction(actionTypes.FETCH_LANGUAGE_SETTINGS);
